var _path, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6983 10.9449C14.7176 10.9216 14.7362 10.8976 14.754 10.8731C15.9502 9.26506 17.893 8.21392 20.0963 8.21392C22.2997 8.21392 24.2425 9.2651 25.4387 10.8732C25.4565 10.8977 25.475 10.9216 25.4943 10.9449C25.6187 11.0951 25.7692 11.2126 25.9342 11.2956C26.0992 11.3789 26.2832 11.43 26.4779 11.4405C26.5081 11.4422 26.5384 11.4429 26.5688 11.4426C30.3267 11.4503 33.2492 14.3298 33.2492 17.7346C33.2492 21.1394 30.3267 24.0189 26.5687 24.0266C26.5384 24.0263 26.5081 24.027 26.4779 24.0287C26.0826 24.0501 25.7317 24.2384 25.4943 24.5243C25.475 24.5476 25.4565 24.5715 25.4387 24.596C24.2425 26.2041 22.2997 27.2552 20.0963 27.2552C17.8929 27.2552 15.9502 26.2041 14.754 24.596C14.7362 24.5715 14.7176 24.5476 14.6983 24.5243C14.5749 24.3752 14.4257 24.2583 14.2621 24.1754C14.0962 24.091 13.9109 24.0393 13.7147 24.0287C13.6845 24.027 13.6542 24.0263 13.6239 24.0266C9.86594 24.0189 6.94341 21.1394 6.94341 17.7346C6.94341 14.3298 9.8659 11.4503 13.6238 11.4426C13.6542 11.4429 13.6845 11.4422 13.7147 11.4405C14.11 11.4191 14.4609 11.2308 14.6983 10.9449ZM27.2326 8.71375C25.5164 6.72227 22.9525 5.46191 20.0963 5.46191C17.2401 5.46191 14.6762 6.72227 12.96 8.71375C8.11637 9.04554 4.19141 12.8982 4.19141 17.7346C4.19141 22.571 8.11638 26.4236 12.96 26.7554C14.6762 28.7469 17.2401 30.0073 20.0963 30.0073C22.9525 30.0073 25.5164 28.7469 27.2326 26.7554C32.0762 26.4236 36.0012 22.571 36.0012 17.7346C36.0012 12.8982 32.0762 9.04554 27.2326 8.71375Z",
    className: "svg-fill-brand"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.13,
    cy: 32.0572,
    r: 2.66323,
    className: "svg-fill-brand-light"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.91611,
    cy: 34.7204,
    r: 1.77549,
    className: "svg-fill-brand-lighter"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialog);
export default __webpack_public_path__ + "static/media/dialog.a9e2155e8d9e870bfec9e82685b72c8d.svg";
export { ForwardRef as ReactComponent };